import { onMounted, ref } from 'vue'

import { normalizeAdvertiserGroups } from '@/lib/adapters/advertiser-groups.adapter'
import { handleErrorMessage } from '@/lib/helpers/error.helpers'
import { makeUrlWithParams } from '@/lib/helpers/query.helpers'
import { request } from '@/lib/services'
import type { AdvertiserGroupType } from '@/lib/types/advertiser-groups.types'
import { useErrorStore } from '@/stores/error'

export const useAdvertiserGroupsRequest = (isReturnAdEnabled?: boolean, size = 100) => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)
  const data = ref<AdvertiserGroupType[]>([])
  const errorStore = useErrorStore()
  const fetchData = async () => {
    try {
      isLoading.value = true
      error.value = null
      const params = {
        return_ad_enabled: isReturnAdEnabled ? '1' : '0',
        size: size.toString(),
      }
      const response = await request.get(makeUrlWithParams('/v2/advertiser-groups', params))
      data.value = normalizeAdvertiserGroups(response.data.data)
    } catch (e: unknown) {
      errorStore.setError(handleErrorMessage(e))
      error.value = e as Error
    } finally {
      isLoading.value = false
    }
  }
  onMounted(() => fetchData())

  return { data, isLoading, error }
}
